import BSN from "bootstrap.native";
import { getMetaValue } from "helpers";
import { ApplicationController } from "../application_controller";


export default class extends ApplicationController {
  // the controller also sits on the tab buttons, only the content container loads the tab
  connect() {
    if (this.data.has("content-url")) {
      this.reload();
    }
  }


  openModalForm(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    this.openLayoutModal(url);
  }


  openModalFormMD(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    this.openLayoutModalMD(url);
  }


  // the whole head row of a partner card opens and closes it (as the sections on the expenses tab)
  collapsePartner(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    let target = event.currentTarget;
    let collapse = new BSN.Collapse(target);
    if (target.classList.contains("collapsed"))
      collapse.show();
    else collapse.hide();
  }


  // the head row is a role="button" element, so Enter and Space work as a click
  collapsePartnerByKey(event) {
    if (event.key === "Enter" || event.key === " ") {
      this.collapsePartner(event);
    }
  }


  // closes all the cards while any of them is open, otherwise opens them all (.toggle-all shows the next action)
  collapseAll(event) {
    event.preventDefault();
    const heads = Array.from(this.element.querySelectorAll(".tps-card__head"));
    const anyOpen = heads.some((head) => !head.classList.contains("collapsed"));

    heads.forEach((head) => {
      const collapse = new BSN.Collapse(head);
      if (anyOpen && !head.classList.contains("collapsed")) collapse.hide();
      if (!anyOpen && head.classList.contains("collapsed")) collapse.show();
    });
    event.currentTarget.classList.toggle("show-all", !anyOpen);
  }


  // also called by the "tps:reload" event when the deal partners change on the info tab
  async reload() {
    const response = await fetch(this.data.get("content-url"), {
      method: "GET",
      headers: {
        "X-CSRF-Token": getMetaValue("csrf-token"),
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/html"
      },
      credentials: "include"
    });

    if (response.status == 200) {
      this.element.innerHTML = await response.text();
    }
  }
}
